import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'

export const useStyles = makeStyles({
  '@global': {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: ' rgba(0, 0, 0, 0.2)'
      },
      '&:hover fieldset': {
        borderColor: '#006BD7'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#006BD7'
      }
    }
  },
  rightBlock: {
    [appTheme.breakpoints.down('lg')]: {
      marginTop: '1rem',
      marginBottom: '5rem'
    }
  },
  leftBlock: {
    float: 'left',
    [appTheme.breakpoints.down('lg')]: {
      width: '100%'
    }
  },
  formLabel: {
    textAlign: 'left',
    width: 'full',
    margin: '1rem',
    '&.MuiFormControlLabel-root': {
      display: 'flex',
      jutifyContent: 'flex-start'
    }
  },
  checkboxGroup: {
    borderRadius: '0.25rem',
    height: 500,
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'inherit'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#808080',
      borderRadius: '1.25rem',
      borderColor: '#E8E8E8'
    },
    marginTop: '1.7rem',
    [appTheme.breakpoints.down('xl')]: {
      height: '600px'
    },
    [appTheme.breakpoints.down('lg')]: {
      marginTop: '0rem'
    },
    padding: '16px 20px'
  },
  errorBox: {
    height: '1.125rem'
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: '8px'
    }
  }
})
